import group from './group'
import member from './members'
export default {
	namespaced: true,
	modules: {
		group,
		member,
	},
}
